import { VFC } from 'react'
import { truewhite, _profilegreen, _profilehrborder } from 'src/styles/colors'
import { fontWeightBold, fontWeightMedium } from 'src/styles/font'
import { leftArrow } from 'src/styles/mixins'
import styled, { SimpleInterpolation } from 'styled-components'
import { asModal } from '../hoc/asModal'
import { CustomLinkify } from '../Linkify'
import { Button } from './ProfileCard'

export type PrDetailCardProps = {
  prDetail?: string
  actions: {
    label: string
    onClick: (params: any) => void
    styles?: SimpleInterpolation
    hidden?: boolean | ((params: any) => boolean)
    disabled?: boolean | ((params: any) => boolean)
  }[]
  userId: number
  showProfileModalWithButton?: () => void
  isDisplayedProfileButton?: true
}

export const PrDetailCard: VFC<PrDetailCardProps> = ({
  prDetail,
  actions,
  userId,
  showProfileModalWithButton,
  isDisplayedProfileButton,
}) => {
  return (
    <Card>
      <p>
        <CustomLinkify>{prDetail || ''}</CustomLinkify>
      </p>
      <Spacer />
      {/* NOTE: メッセージ一覧のPRの時のみ表示する */}
      {isDisplayedProfileButton && (
        <DetailButtonDiv>
          <button
            onClick={() =>
              showProfileModalWithButton ? showProfileModalWithButton() : {}
            }
          >
            詳細プロフィールを見る
          </button>
        </DetailButtonDiv>
      )}
      <Buttons>
        {actions.map(({ label, onClick, styles, hidden, disabled }) => (
          <Button
            key={label}
            onClick={() => onClick(userId)}
            styles={styles}
            hidden={typeof hidden === 'function' ? hidden(userId) : hidden}
            disabled={
              typeof disabled === 'function' ? disabled(userId) : disabled
            }
            numOfSiblings={actions.length}
          >
            {label}
          </Button>
        ))}
      </Buttons>
    </Card>
  )
}

const PrDetailCardPreview: VFC<PrDetailCardProps> = (props) => {
  return (
    <Layout>
      <PrDetailCard {...props} />
    </Layout>
  )
}

export const PrDetailCardModal = asModal(PrDetailCardPreview, {
  scrollable: true,
})

const Layout = styled.div`
  width: 100%;
  min-width: max(40vw, 260px);
  max-width: min(80vw, 800px);
  overflow-y: auto;
  border-radius: 20px;
`

const Card = styled.div`
  background-color: ${truewhite};
  padding: 30px;
  font-weight: ${fontWeightMedium};
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.6px;
  white-space: pre-wrap;
  word-wrap: break-word;
`

const Spacer = styled.hr`
  margin-top: 20px;
  height: 1px;
  border: 0;
  background: ${_profilehrborder};
`

const DetailButtonDiv = styled.div`
  text-align: center;
  margin-top: 30px;

  button {
    color: ${_profilegreen};
    border: 1px solid;
    border-radius: 5px;
    padding: 10px 40px 10px 20px;
    font-weight: ${fontWeightBold};

    ${leftArrow};
    ::after {
      border-width: 2px;
      top: -5%;
    }
    :focus,
    :hover {
      color: ${truewhite};
      background-color: ${_profilegreen};
    }
  }
`

const Buttons = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding-top: 10px;
  width: 100%;
  > * {
    margin-top: 20px;
  }
`
